module.exports = __webpack_public_path__ + "img/incein-circle-2.eb50c2c4.svg";